
export const apiUrl = process.env.API_URL;
export const version = process.env.VERSION;
export const version_release_date = process.env.VERSION_RELEASE_DATE;
export const cdnDomain = process.env.CDN_DOMAIN;
export const userTokenStorageKey = 'APP_USER_TOKEN';
export const remediatorAPIServerURL = apiUrl;
export const sentry_id =  ""
export const baseServerUrl = process.env.BASE_API_URL || "https://api.emailremediator.com";
export const auth_token = process.env.TOKEN_UI;
// export const sentry_id = "";
// export const remediatorAPIServerURL = 'http://localhost:4040/api/v1/';
export const adsso = process.env.adsso || "no"
export const o365sso = process.env.o365sso || "no"
export const gsuitsso = process.env.gsuitsso || "yes"
export const socket_url = process.env.SOCKET_URL || "https://ws.emailremediator.com";
export const socket_path_ui = process.env.SOCKET_PATH_UI || '/search_api/socket.io';
export const recaptcha_key = process.env.RECAPTCHA_PUBLIC_KEY || "6LeIresUAAAAAD-0OanV4YaLr4ybeNdw3b6-EQkt";
// export const socket_url = "https://ws.emailremediator.com"
// export const socket_url = "reporter.dewa.gov.ae/search_api"
// export const remediatorAPIServerURL= apiUrl // 'https://api.emailremediator.com/api/v1/'



// WEBPACK FOOTER //
// ./src/config.js